// extracted by mini-css-extract-plugin
export default {"printViewBlock":"printBlock_printViewBlock__EpIhk","printBlock":"printBlock_printBlock__yLvYr"};